import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  baseplateFinishes: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
